function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var extensionPattern = /chrome-extension:\/\/(?!cfpbkbmjlakpfdghiheojfipcmhhbjmj)/;
var noiseRules = [function (_ref) {
  var messageStr = _ref.messageStr;
  return /^SecurityError( \(DOM Exception 18\))?: Blocked a frame with origin "[^"]*" from accessing a frame with origin "https:\/\/accounts\.google\.com"\. Protocols, domains, and ports must match\./.test(messageStr);
}, function (_ref2) {
  var messageStr = _ref2.messageStr,
    stack = _ref2.stack;
  return extensionPattern.test(messageStr) || !!stack && extensionPattern.test(stack);
}, function (_ref3) {
  var messageStr = _ref3.messageStr;
  return messageStr.includes('originalAddEventListener is not defined');
}, function (_ref4) {
  var messageStr = _ref4.messageStr;
  return messageStr.includes('__gCrWeb.autofill.extractForms');
}, function (_ref5) {
  var messageStr = _ref5.messageStr,
    stack = _ref5.stack;
  return messageStr === 'Script error.' && !stack;
}, function (_ref6) {
  var messageStr = _ref6.messageStr;
  return messageStr === 'ResizeObserver loop limit exceeded' || messageStr === 'ResizeObserver loop completed with undelivered notifications.';
}, function (_ref7) {
  var messageStr = _ref7.messageStr;
  return /^(Hydration failed|Text content does not match|There was an error while hydrating)/.test(messageStr);
}, function (_ref8) {
  var error = _ref8.error,
    messageStr = _ref8.messageStr;
  return error instanceof Error && error.name === 'AbortError' || messageStr.startsWith('AbortError:') || messageStr.includes('Failed to fetch') || messageStr === 'Load failed' || messageStr === 'NetworkError when attempting to fetch resource.';
}];
export default function shouldDropErrorReport(error, messageOverride) {
  var messageStr = messageOverride !== null && messageOverride !== void 0 ? messageOverride : extractMessage(error);
  var stack = extractStack(error);
  return noiseRules.some(function (rule) {
    return rule({
      error: error,
      messageStr: messageStr,
      stack: stack
    });
  });
}
function extractMessage(error) {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error && _typeof(error) === 'object') {
    var _ref9 = error,
      message = _ref9.message;
    if (typeof message === 'string') {
      return message;
    }
  }
  return '';
}
function extractStack(error) {
  if (error instanceof Error) {
    return error.stack;
  }
  var candidate = error === null || error === void 0 ? void 0 : error.stack;
  return typeof candidate === 'string' ? candidate : undefined;
}